module.exports = __webpack_public_path__ + "img/logo-migrated.3e01d40d.svg";